import { Box, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const contents = [
  'Người trên 70 hoặc dưới 14 tuổi',
  'Người đang dùng thuốc lợi tiểu, thuốc an thần và thuốc chống co giật',
  'Người có các triệu chứng như rối loạn đi bộ, choáng váng và chóng mặt',
  'Người bị suy nhược, rối loạn thị lực và thính giác, rối loạn tiểu tiện và bài tiết, loãng xương',
  'Người có nguy cơ bị ngã',
];

const CautionList = () => {
  return (
    <>
      <SectionTitle title="Vui lòng đặc biệt cẩn thận khi ngã nếu bạn thuộc các hạng mục dưới đây" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{ fontWeight: '400', fontSize: '14px', lineHeight: '40px' }}
          >
            {i + 1}) {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default CautionList;
